import { ActionTypes } from '../constants';
import { RootActionTypes } from '../../../stores/types';

export default function resetHs6Pagination(): RootActionTypes {
  return {
    type: ActionTypes.RESET_HS6_PAGINATION,
  };
}
